import React from "react";
import { FaArrowRight } from "react-icons/fa";

export const Community = () => {
  return (
    <section className="py-8">
      <div className="mx-4 md:mx-12 lg:mx-24 md:py-16">
        <p className="uppercase text-sm text-orange">Community</p>

        <div className="grid grid-cols-12 py-4 items-center">
          <div className="col-span-full md:col-span-6">
            <p className="text-3xl md:text-3xl lg:text-5xl md:mr-24 ">
              You’re in good company
            </p>
          </div>
          <div className="col-span-full md:col-span-6 py-8 md:py-0 md:pl-14">
            <p className="text-blue-4 w-full lg:w-3/4">
              Lemon Squeezy is the heartbeat for your business. Join thousands
              of successful startups, software companies, and digital creators
              using our platform.{" "}
              <span className="text-black">
                Become part of a growing community{" "}
              </span>
              of innovative thinkers, makers, movers, and shakers — you're in
              good company here.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 mt-24 space-y-16">
          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              "I'm moving the Serverless Laravel course to Lemon Squeezy and
              will host my new course there too. They have completely solved the
              Google Analytics issue by offering to disable Google Pay for my
              checkout"
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-1.png" alt="profile" />
              </div>
              <div>
                <p className="text-md">Jack Ellis</p>
                <p className="text-sm text-blue-2">usefathom.com</p>
              </div>
            </div>
          </div>

          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              "Imagine having a team of designers, developers, email marketers,
              and tax accountants behind you. That’s how Lemon Squeezy feels,
              letting you focus on creating your digital products."
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-2.png" alt="profile" />
              </div>
              <div>
                <p className="text-md">Shahadat Rahman</p>
                <p className="text-sm text-blue-2">@HiShahadat</p>
              </div>
            </div>
          </div>

          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              “Lemon Squeezy is exactly what I have been looking for. The
              license key management and recurring payments have streamlined my
              business, and I am looking forward to seeing the platform grow.”
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-3.png" alt="profile" />
              </div>
              <div>
                <p className="text-md">UiPress</p>
                <p className="text-sm text-blue-2">uipress.co</p>
              </div>
            </div>
          </div>

          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              “When launching Iconic, Lemon Squeezy literally took care of
              everything. No need to think about taxes, VAT, license keys, etc.
              The setup really was easy-peasy.”
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-4.png" alt="profile" />
              </div>
              <div>
                <p className="text-md">James McDonald</p>
                <p className="text-sm text-blue-2">iconic.app</p>
              </div>
            </div>
          </div>

          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              "Lemon Squeezy had the perfect combination of features for selling
              my first software product. It’s been so easy to set up, and
              customer support has been amazing."
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-5.png" alt="profile" />
              </div>
              <div>
                <p className="text-md">Ross Wintle</p>
                <p className="text-sm text-blue-2">turbo-admin.com</p>
              </div>
            </div>
          </div>

          <div className="col-span-full md:col-span-6 lg:col-span-4">
            <p className="w-full md:w-3/4">
              "I’ve never come across a platform that has made it SO easy-peasy
              to start selling. Lemon Squeezy is full of beautiful surprises,
              and it’s a genuine joy to use!"
            </p>
            <div className="flex gap-4 mt-8 items-center">
              <div>
                <img src="/images/prof-6.png" alt="prof" />
              </div>
              <div>
                <p className="text-md">Rachel Shillcock</p>
                <p className="text-sm text-blue-2">@MissRachilli</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 pt-4 md:pt-16 items-center">
        <div className="col-span-full md:col-span-6 py-12 md:py-12 px-4 md:pl-16 lg:pl-24 w-full md:pr-8 lg:pr-0 lg:w-3/4">
          <p className="text-orange uppercase text-sm">c/1</p>
          <h1 className="text-2xl pt-8 w-full lg:w-3/4">
            How Iconic uses Lemon Squeezy to power software licensing +
            subscriptions
          </h1>

          <button className="mt-6 px-5 py-2 text-white bg-orange rounded-full flex gap-2 items-center">
            Read the case study <FaArrowRight color="white" />{" "}
          </button>
        </div>

        <div className="col-span-full md:col-span-6">
          <img src="/images/dev-2.svg" alt="dev" />
        </div>

        <div className="col-span-full md:col-span-6">
          <img src="/images/dev-1.svg" alt="dev" />
        </div>
        <div className="col-span-full md:col-span-6 px-4 md:pl-16 pt-8 md:pt-0 w-full md:pr-12 lg:w-2/3">
          <p className="text-orange uppercase text-sm">c/2</p>
          <h1 className="text-2xl pt-8">
            How Figma Academy used Lemon Squeezy to earn $300k with a Figma
            course
          </h1>

          <button className="mt-6 px-5 py-2 text-white bg-orange rounded-full flex gap-2 items-center">
            Read the case study <FaArrowRight color="white" />{" "}
          </button>
        </div>
      </div>
    </section>
  );
};
